// removed by extract-text-webpack-plugin
module.exports = {"container-funded":"PGZud","message":"_29WeX","action-container":"_1Llhd","action-link":"_30Gnh","discover":"_3eYhG","timer":"kWNY_","closed":"v0o7X"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Prompt/PromptClosed.scss
// module id = ./src/components/Prompt/PromptClosed.scss
// module chunks = 5